
import {Component, Vue, Watch} from 'vue-property-decorator'
import {CommonModule} from '@/store/module/common'
import {UserModule} from '@/store/module/user'
import {menuData, filterItem, menuData1} from './menuData'
import {IMenuData, ISubMenuData} from '@/@types/global'
import {asideTest, getSubMenuList} from '@/api/common'
import {eventBus} from '@/main'

@Component({
	name: 'SideBar'
})

export default class SideBar extends Vue {

	menuData: IMenuData[] = []
	menuData1: IMenuData[] = []
	// }
	currentMenuId = ''
	currentSubMenuId = ''
	filterItem: ISubMenuData[] = []

	async created() {
		this.$nextTick(() => {
			eventBus.$on('clickPriceTask', this.handleSubTaskClick)
		})
	}

	get userRole() {
		return UserModule.userInfo.roleID
	}

	// mounted() {
	//   this.menuData = []
	//   // console.log(this.menuData1, '111');

	get menuRole() {
		return UserModule.userInfo.right
	}

	get isNeedInitMenu() {
		return CommonModule.isNeedInitMenu
	}

	async handleSubTaskClick(code: string, subItem: number) {
		console.log(this.menuData)
		const menu = this.menuData.filter(item => item.id == code)[0];
		await this.handleClickMenu(menu);
		const subMenu = menu.children.filter(item => item.id == subItem)[0]
		this.openPage(subMenu)
	}

	@Watch('isNeedInitMenu', {immediate: true})
	async handleInitMenu() {
		if (this.isNeedInitMenu) {
			await this.initMenuData()
			// console.log(this.menuData);

			this.initNavStatus()
			CommonModule.HANDLE_INIT_MENU(false)
		}
	}

	async handleClickMenu(item: any, status = false) {
		console.log(item)
		const normalMenuIdList = ['homePage', 'manager', 'tools', 'userManager', 'agency']
		const subMenuId = localStorage.getItem('subMenuId')
		//this.menuData.forEach(i => (i.isActive = false))
		if (this.currentMenuId !== item.id) {
			if (normalMenuIdList.includes(item.id)) {

				// 固定子菜单部分，直接显示即可
				item.isActive = true
				if (status) {
					// 需要针对初始化的情况做处理，这部分不需要请求接口，因此可以直接显示子菜单状态
					const tmp = item.children.find(i => i.id === subMenuId)
					if (tmp) {
						tmp.isActive = true
						CommonModule.SET_SELECTED_SUB_ITEM(tmp)
					}
				}
			} else {
				// 需要请求接口获取数据
				if (item.children.length === 0) {
					await getSubMenuList({platform: item.id}).then(res => {
						const {data} = res
						item.children.push(
							...data.map((j: ISubMenuData) => {
								return {
									...j,
									name: j.Name,
									id: j.ID,
									path: item.id === 'agent' || item.id === 'black' ? '/myFilter/index' : '/common/create',
									isActive: false
								}
							})
						)
						item.children.unshift({
							name: '所有任务',
							id: 999,
							isActive: false,
							path: '/common/create'
						})
						item.height = item.children.length * 40 + 50
						item.isActive = true
						const temp = item.children.find(k => k.id === +subMenuId)
						if (temp) {
							temp.isActive = true
							CommonModule.SET_SELECTED_SUB_ITEM(temp)
						}
						if (status) this.changeExtFields(temp)
					})
				} else {
					// 分开的原因是，上面是接口请求，会先展开空白然后再回显数据
					item.isActive = !item.isActive
				}
			}
			this.currentMenuId = item.id
		} else {
			item.isActive = !item.isActive
		}
		// console.log(item.isActive)
	}

	openPage(subItem: any) {
		console.log(subItem)
		this.currentSubMenuId = subItem.id
		// 恢复初始状态，然后再改变菜单状态
		this.resetMenuStatus()
		subItem.isActive = true
		const temp = this.menuData.find(i => i.id === this.currentMenuId)
		if (temp) temp.isActive = true
		// 缓存id
		localStorage.setItem('subMenuId', subItem.id)
		localStorage.setItem('menuId', this.currentMenuId)
		CommonModule.SET_MENU_ID(this.currentMenuId)
		CommonModule.SET_SUBMENU_ID(subItem.id)
		CommonModule.SET_SELECTED_SUB_ITEM(subItem)
		// 页面地址跟当前的一样，那么不需要再次跳转，只需要初始化一下接口即可
		// 否则跳转页面，并且请求接口
		if (this.$route.path !== subItem.path) {
			this.$router.push(subItem.path)
		}
		// 初始化额外字段
		this.changeExtFields(subItem)
		CommonModule.HANDLE_INIT_STORE_DATA(true)
	}

	async initMenuData() {
		this.menuData = []
		const newMenuData: any = [...menuData1]
		// 获取菜单数据
		const res = await asideTest()
		console.log(res);
		let obj2 = {}
		res.data.forEach((item: any) => {
			let rightObj = {
				name: item.Name,
				id: 'f' + item.Code,
				isActive: false,
				path: '/filterManager/index'
			}

			this.filterItem.push(rightObj)

			let obj: any = {
				name: item.Name,
				id: item.Code,
				icon: item.Code,
				isActive: false,
				children: []
			}

			newMenuData.push(obj)
		})
		obj2 = {
			name: '筛选管理',
			id: 'filterManager',
			icon: 'tools',
			isActive: false,
			children: this.filterItem,
		}
		newMenuData.splice(3, 0, obj2)
		// newMenuData[newMenuData.length - 1].children = this.filterItem
		// 初始化菜单数据，由于权限控制的问题，会导致某些模块下的菜单部分会隐藏，因此要重新计算高度
		this.menuData = newMenuData.map((item: any) => {
			if (this.userRole === 1) {
				return {
					...item,
					icon: 'icon-' + item.icon,
					iconPath: item.iconPath ? require(`@/assets/sprite/${item.iconPath}`) : null,
					height: item.children.length * 40 + 50
				}
			} else {
				if (item.id === 'homePage') {
					// 普通角色
					let num = 0
					const temp = ['cmx', 'cye', 'ccz', 'comment']
					temp.forEach(i => {
						if (this.menuRole?.includes(i)) {
							num++
						}
					})
					return {
						...item,
						icon: 'icon-' + item.icon,
						iconPath: item.iconPath ? require(`@/assets/sprite/${item.iconPath}`) : null,
						height: num * 40 + 50
					}
				} else if (this.userRole !== 2 && item.id === 'manager') {
					console.log(item.children);

					// 客服角色或其他角色
					let num = 5
					//const temp = ['zh', 'ye', 'cz', 'mx', 'ma', 'log', 'cmx', 'cye', 'ccz', 'nr']

					//temp.forEach(i => {
					//    if (this.menuRole?.includes(i)) {
					//        num++
					//    }
					//})
					return {
						...item,
						icon: 'icon-' + item.icon,
						iconPath: item.iconPath ? require(`@/assets/img/${item.iconPath}`) : null,
						height: num * 40 + 50
					}
				} else {
					return {
						...item,
						icon: 'icon-' + item.icon,
						iconPath: item.iconPath ? require(`@/assets/img/${item.iconPath}`) : null,
						height: item.children.length * 40 + 50
					}
				}
			}
		})

		// console.log(this.menuData)
	}

	initNavStatus() {
		// 初始化菜单状态
		const menuId = localStorage.getItem('menuId')
		const temp = this.menuData.find(item => item.id === menuId)
		console.log(temp, 'temp')
		if (temp) {
			temp.isActive = true
			this.handleClickMenu(temp, true)
		}
	}

	resetMenuStatus() {

		// 重置导航的展开状态
		this.menuData.forEach(item => {
			item.isActive = false
			if (item.children) {
				item.children.forEach(sub => {
					sub.isActive = false
				})
			}
		})
	}

	// 点击子菜单修改额外字段
	changeExtFields(item: any) {
		// 提交到store存储
		CommonModule.INIT_EXT_FIELDS(item)
	}

	// 菜单权限控制
	isShowMenu(item: any) {
		// 超管不处理，只处理其他用户
		if (this.userRole !== 1) {
			if (item.id === 'manager' && this.userRole !== 3) {
				return false
			} else if (item.id === 'homePage' && this.userRole !== 4) {
				return true
			} else {
				if (this.menuRole?.includes(item.id)) {
					return true
				} else {
					return false
				}
			}
		} else {
			if (item.id === 'agency') {
				return false
			}
			return true
		}
	}

	isShowSubMenu(item: any, subItem: any) {
		// 子菜单权限控制
		if (this.userRole !== 1) {
			if (subItem.id === 'home') {
				return true
			}
			if (item.id === 'homePage' || item.id === 'tools' || item.id === 'manager') {
				// console.log(this.menuRole)
				if (this.menuRole?.includes(subItem.id)) {
					return true
				} else {
					return false
				}
			}
		}
		return true
	}

	changeBillStatus() {
		// 点击顶部导航“账单管理”时，修改菜单状态
		this.menuData.forEach(item => {
			item.isActive = false
			if (item.id === 'custom') item.isActive = true
			if (item.children) {
				item.children.forEach(sub => {
					sub.isActive = false
					if (sub.id === 'cmx') sub.isActive = true
				})
			}
		})
	}

	beforeRouteLeave(to: any, from: any, next: any) {
		this.menuData = []
		console.log("准备离开路由执行")
		next(
			console.log("离开路由之后执行")
		);
	}
}
